import React from 'react';
import { getAllParams } from '../service/utils';

const AccessibilityHiddenImg = ({ ...params }) => {

    return (
        <img {...getAllParams(params)} alt="" />
    );
};

export default AccessibilityHiddenImg;
